import React, { useEffect, useState } from 'react';

function AxisBottomRenderTick({ config }) {
  const {
    tickIndex,
    animatedProps,
    textAnchor,
    textBaseline,
    textX,
    textY,
    value,
    x,
    y,
    rotate,
    //
    isRenderTick,
    theme,
  } = config;
  const [opacity, setOpacity] = useState(animatedProps.opacity.animation.from);

  useEffect(() => {
    setOpacity(animatedProps.opacity.animation.to);
  }, []);

  return (
    <g
      transform={`translate(${x},${y})`}
      style={{
        opacity,
        transition: 'all 0.2s',
      }}
    >
      <text
        style={{
          fontFamily: theme.fontFamily,
          fill: theme.textColor,
          fontSize: theme.axis.ticks.text.fontSize,
        }}
        alignmentBaseline={textBaseline}
        textAnchor={textAnchor}
        transform={`translate(${textX},${textY}) rotate(${rotate})`}
      >
        {isRenderTick && value.length > 5 ? (
          <>
            <tspan x={0} y={11}>
              {value.slice(0, 5)}
            </tspan>
            <tspan x={0} y={11 + 11}>
              {value.slice(5)}
            </tspan>
          </>
        ) : (
          <tspan x={0} y={11}>
            {value}
          </tspan>
        )}
      </text>
    </g>
  );
}

export default AxisBottomRenderTick;
